<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title"> Báo cáo</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('report_repair_warranty_maintenance', 'list')">
        <div class="p-grid box-row-data">
          <div class="p-col-6" style="padding-left: 0px;" ><span style="font-weight: 700; font-style: normal; font-size: 20px;">Sửa chữa - bảo hành - bảo trì sản phẩm</span></div>
          <div class="p-col-6 text-right"><Button class="p-button-warning" :label="'Quay lại'"  @click="backList"  /></div>
        </div>
        <div class="p-grid box-row-data">
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Ngày tiếp nhận <span class="error">*</span></label>
            <div class="box">
              <Calendar dateFormat="dd/mm/yy" v-model="list_filter_data['start_date_filter']" style="width: calc(50% - 10px);" placeholder="Từ ngày"  @date-select="onFilter($event,'date_from_to','start_date_filter')" />
              -
              <Calendar dateFormat="dd/mm/yy" v-model="list_filter_data['end_date_filter']" style="width: calc(50% - 10px);" placeholder="Đến ngày" @date-select="onFilter($event,'date_from_to','end_date_filter')" />
            </div>
            <small v-if="validationErrors && validationErrors['start_date_filter']" class="p-invalid" >{{validationErrors['start_date_filter']}}</small>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Đơn vị thực hiện</label>
            <div class="box">
              <MultiSelect style="width: 100%;" v-model="list_filter_data['selected_organization_filter']" :filter="true" :options="list_filter_organization" optionLabel="name" optionValue="id" placeholder="Tất cả" @change="onFilter($event,'MultiSelect','selected_organization_filter')" />
              <!--<Dropdown  style="width: 100%;" :filter="true"   placeholder="Chọn đơn vị" inputId="organization_id"  optionLabel="label"  optionValue="value" />-->
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Loại nguyên nhân hư hỏng</label>
            <div class="box">
              <MultiSelect style="width: 100%;" v-model="list_filter_data['selected_type_failure_cause']" :filter="true" :options="list_type_failure_cause" optionLabel="name" optionValue="id" placeholder="Tất cả" @change="onFilter($event,'MultiSelect','selected_type_failure_cause')"/>
              <!--<Dropdown  style="width: 100%;" :filter="true"   placeholder="Chọn đơn vị" inputId="organization_id"  optionLabel="label"  optionValue="value" />-->
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Lệnh sản xuất</label>
            <div class="box">
              <InputText style="width: 100%;" type="text" v-model="list_filter_data['input_work_order']" maxlength="255" @change="onFilter($event,'input','input_work_order')" />
            </div>
          </div>
        </div>
        <div class="p-grid box-row-data">
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Loại dịch vụ</label>
            <div class="box">
              <MultiSelect style="width: 100%;" v-model="list_filter_data['selected_service_filter']" :filter="true" :options="list_filter_service_status" optionLabel="name" optionValue="code" placeholder="Tất cả" @change="onFilter($event,'MultiSelect','selected_service_filter')" />
              <!--<Dropdown  style="width: 100%;" :filter="true"   placeholder="Chọn đơn vị" inputId="organization_id"  optionLabel="label"  optionValue="value" />-->
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Trạng thái thực hiện</label>
            <div class="box">
              <MultiSelect style="width: 100%;" v-model="list_filter_data['selected_process_product_status_filter']" :filter="true" :options="list_filter_process_product_status" optionLabel="label" optionValue="value" placeholder="Tất cả" @change="onFilter($event,'MultiSelect','selected_process_product_status_filter')" />
              <!--<Dropdown  style="width: 100%;" :filter="true"   placeholder="Chọn đơn vị" inputId="organization_id"  optionLabel="label"  optionValue="value" />-->
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Model sản phẩm</label>
            <div class="box">
              <MultiSelect style="width: 100%;" v-model="list_filter_data['selected_product_filter']" :filter="true" :options="list_filter_product" optionLabel="name" optionValue="value" placeholder="Tất cả" @change="onFilter($event,'MultiSelect','selected_product_filter')" />
              <!--<Dropdown  style="width: 100%;" :filter="true"   placeholder="Chọn đơn vị" inputId="organization_id"  optionLabel="label"  optionValue="value" />-->
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data box-button-filter">
            <div class="box box-item-button-filter">
              <Button
                  style="width: 96px"
                  class="p-button-info btn-custom"
                  :label="'Áp dụng'"
                  type="button"
                  @click="process_filter"
              > </Button>
              <Button
                  style="margin-left: 16px;width: 96px"
                  class="p-button-danger btn-custom"
                  :label="'Hủy'"
                  @click="cancel_filter"
              />

            </div>
          </div>
        </div>
        <div class="p-grid box-row-data">
          <div class="p-col-6" style="padding-left: 0px;" ><span style="font-weight: 700; font-style: normal; font-size: 16px;">TỔNG QUAN</span></div>
        </div>
        <div class="p-grid box-row-data">
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <div class="box">
              <span style="font-family:'Arial';font-weight:400;">• Bảo hành sản phẩm: <span class="custom-number-overview">{{totalWarranty}}</span> sản phẩm</span>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <div class="box">
              <span style="font-family:'Arial';font-weight:400;">• Sửa chữa tính phí: <span class="custom-number-overview">{{ totalRepair }}</span> sản phẩm</span>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <div class="box">
            <span style="font-family:'Arial';font-weight:400;">• Bảo trì định kỳ: <span class="custom-number-overview">{{ totalMaintenance }}</span> sản phẩm</span>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <div class="box">
            <span style="font-family:'Arial';font-weight:400;">• Sửa chữa SP thẩm định: <span class="custom-number-overview">{{ totalRepairAppraisal }}</span> sản phẩm</span>
            </div>
          </div>
        </div>
        <div class="p-grid box-row-data">
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <div class="box">
              <span style="font-family:'Arial';font-weight:400;">• Khảo sát - thẩm định: <span class="custom-number-overview">{{totalAppraisal}}</span> sản phẩm</span>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <div class="box">
              <span style="font-family:'Arial';font-weight:400;">• Lắp đặt - vận hành: <span class="custom-number-overview">{{ totalOperation }}</span> sản phẩm</span>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <div class="box">
            <span style="font-family:'Arial';font-weight:400;">• Nghiệm thu: <span class="custom-number-overview">{{ totalAcceptance }}</span> sản phẩm</span>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <div class="box">
            <span style="font-family:'Arial';font-weight:400;">• Tư vấn - đào tạo: <span class="custom-number-overview">{{ totalTraining }}</span> sản phẩm</span>
            </div>
          </div>
        </div>

        <div class="p-grid box-row-data">
          <div class="p-col-12 p-md-6 p-lg-8 box-item-data">
            <div class="box">
              <div class="import-data download-data" ><!--v-if="$myConstants.checkRoleGroup('maintenance', 'download')"-->
                <button :disabled="DisableExport == true" class="download-file" @click="exportDataExcel" >
                  <i class="pi pi-download"></i>Xuất dữ liệu
                </button>
                <span >(Dữ liệu được xuất theo thông tin hiển thị ở bảng bên dưới)</span>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 box-item-data" style="text-align: right">
            <div class="box">
              <span >Hiển thị <b>{{ list_colunm_display.length }}</b>/<b>{{ list_column_select.length }}</b> cột</span>
              <MultiSelect style="margin-left: 8px;max-width: 120px" v-model="list_colunm_display" :filter="true" :options="list_column_select" optionLabel="name" optionValue="key" placeholder="Chọn cột" @before-hide="process_load_data" />
            </div>
          </div>
        </div>
        <div class="list-data" ><!--v-if="$myConstants.checkRoleGroup('maintenance', 'list')"-->
          <!--<div class="list-title">
            <span class="p-m-0">Danh sách kế hoạch bảo trì định kỳ</span>
            <span class="p-input-icon-left" v-if="$myConstants.checkRoleGroup('maintenance', 'update_status')">
              <Button
              :style="(disable_update) ? 'background-color: rgba(153, 153, 153, 1);border: 1px solid #c8c9c9;':''"
              :disabled="disable_update"
              :label="'Cập nhật'"
              type="button"
              v-on:click="update_assignment()"
              > </Button>
            </span>
          </div>-->
          <BaseCommon v-if="dataModel"
            :labelHeaderAction="'Chi tiết'"
            :classDatatable="'list_warranty_activation'"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            :dateTypeDateFilterDefault="dateTypeDateFilterDefault"
            :map_custom_filter="map_custom_filter"
            @filter="filterData"
            v-on:action-click="onActionClicked"
            :actions="getRowActions()"
            @callback="callbackListData"
            @info_overview="info_overview"
            :columnsDisplays="columnsDisplays"
            @filterExport="whereExport"
          ></BaseCommon>
        </div>
      </div>
    </div>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div v-if="creenConfirmDialog == 'export_success'">
          <div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          <p class="p_title_1" style="text-align: left">Báo cáo <span style="font-weight: 700">Sửa chữa - bảo hành - bảo trì sản phẩm</span> đã xuất dữ liệu thành công. Vui lòng thực hiện tải về tại module Lịch sử xuất dữ liệu.</p>
          <div class="box_btn">
            <Button
                icon="pi pi-chevron-circle-right"
                iconPos="right"
                class="btn-custom"
                :label="'Lịch sử xuất dữ liệu'"
                type="button"
                @click="redirect_ToHistory"
            > </Button>
          </div>
        </div>
        <div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu báo cáo <span style="font-weight: 700;">Kích hoạt bảo hành sản phẩm</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
    <!--<OverlayPanel ref="op" :dismissable="false" style="width: 335px;">
      <Listbox  v-model="selectedCountries" :options="countries" :multiple="true" :filter="true" optionLabel="name" listStyle="max-height:250px" style="width:100%">
        <template #option="slotProps">
          <div class="country-item">
           &lt;!&ndash; <img src="../../assets/images/flag_placeholder.png" :class="'flag flag-' + slotProps.option.code.toLowerCase()" />&ndash;&gt;
            <div>{{slotProps.option.name}}</div>
          </div>
        </template>
      </Listbox>
    </OverlayPanel>-->
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from './core_list';
import moment from "moment";
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      disable_update:true,
      listDataExport:[],
      showConfirmDialog:false,
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      dateTypeDateFilterDefault:null,
      start_date_filter:null,
      end_date_filter:null,
      selected_organization_filter:null,
      list_filter_organization:[],
      selected_process_product_status_filter:null,
      list_type_failure_cause:[],
      selected_service_filter:null,
      list_filter_process_product_status:[{value: 7, label: 'Từ chối tiếp nhận'},{value: 8, label: 'Đã hỗ trợ xong'},{value: 6, label: 'Đồng ý tiếp nhận'},{value: 0, label: 'Chờ thực hiện'},{value: 1, label: 'Đã thực hiện'},{value: 2, label: 'KH từ chối'},{value: 3, label: 'Không thực hiện'},{value: 4, label: 'Đề nghị hủy SP'}],
      selected_product_filter:null,
      list_filter_product:[],
      selected_warranty_status_filter:null,
      list_filter_service_status:[],
      list_filter_data: {},
      map_custom_filter:[],
      validationErrors: {},
      totalActivatedProduct:0,
      totalCustomer:0,
      columnsDisplays:[],
      input_work_order : null,
      list_colunm_display:[
          "model_code_text","name_text", "serial_number_text","production_order_code_text","activation_date_text",
          "expired_activation_date_text","customer_name_text","customer_phone_text","creator_organization_name_text","creator_organization_provinces_text",
          "receive_day_reception_text","receive_sender_text","receive_sender_name_text","receive_sender_phone_text",
          "receive_sender_organization_text","receive_method_text","receive_note_text","delivery_return_appointment_day_text",
          "delivery_relative_receiving_name_text","delivery_relative_receiving_phone_text","delivery_relative_receiving_organization_text",
          "delivery_method_text","code_text","type_service_text","parts_number_text","process_product_status_text","process_status_text",
          "technical_user_name_text","type_failure_cause_text","modified_date_text"
      ],//Số cột hiển thị
      list_column_select:[
        {key:'model_code_text',name:'Model'},
        {key:'name_text',name:'Tên sản phẩm'},
        {key:'categories_text',name:'Loại sản phẩm'},
        {key:'serial_number_text',name:'Serial number'},
        {key:'production_order_code_text',name:'Lệnh sản xuất'},
        {key:'activation_date_text',name:'Ngày kích hoạt'},
        {key:'expired_activation_date_text',name:'Ngày hết hạn BH'},
        {key:'customer_name_text',name:'Tên khách hàng'},
        {key:'customer_phone_text',name:'SĐT khách hàng'},
        {key:'customer_address_text',name:'Địa chỉ khách hàng'},
        {key:'creator_organization_name_text',name:'Đơn vị thực hiện'},
        {key:'creator_organization_phone_text',name:'SĐT đơn vị'},
        {key:'creator_organization_provinces_text',name:'Tỉnh/TP của đơn vị'},
        {key:'modifier_name_text',name:'Nhân viên cập nhật'},
        {key:'receive_day_reception_text',name:'Ngày tiếp nhận'},
        {key:'receive_sender_text',name:'Đối tượng gửi'},
        {key:'receive_sender_name_text',name:'Tên người gửi'},
        {key:'receive_sender_phone_text',name:'SĐT người gửi'},
        {key:'receive_sender_organization_text',name:'Đơn vị của người gửi'},
        {key:'receive_method_text',name:'Hình thức tiếp nhận'},
        {key:'receive_note_text',name:'Ghi chú'},
        {key:'delivery_return_appointment_day_text',name:'Ngày hẹn trả'},
        {key:'delivery_relative_receiving_text',name:'Đối tượng nhận'},
        {key:'delivery_relative_receiving_name_text',name:'Tên người nhận'},
        {key:'delivery_relative_receiving_phone_text',name:'SĐT người nhận'},
        {key:'delivery_relative_receiving_organization_text',name:'Đơn vị của người nhận'},
        {key:'delivery_method_text',name:'Hình thức giao trả'},
        {key:'delivery_address_text',name:'Địa chỉ nhận'},
        {key:'code_text',name:'Mã dịch vụ'},
        {key:'type_service_text',name:'Loại dịch vụ'},
        {key:'parts_number_text',name:'Đợt bảo trì'},
        {key:'process_product_status_text',name:'Trạng thái thực hiện'},
        {key:'process_status_text',name:'Tiến độ thực hiện'},
        {key:'technical_user_name_text',name:'Nhân viên kỹ thuật'},
        {key:'check_presently_damaged_text',name:'Hiện tượng hư hỏng'},
        {key:'type_failure_cause_text',name:'Loại nguyên nhân hư hỏng'},
        {key:'check_cause_damage_text',name:'Nguyên nhân hư hỏng'},
        {key:'check_proposed_solutions_text',name:'Giải pháp đề xuất'},
        {key:'check_result_text',name:'Kết quả kiểm tra'},
        {key:'check_reason_text',name:'Nội dung/Lý do chi tiết'},
        {key:'service_total_price_service_text',name:'Tổng cộng'},
        {key:'service_total_discount_text',name:'%Giảm giá'},
        {key:'service_total_money_discount_text',name:'Tiền giảm giá'},
        {key:'service_tax_text',name:'%Thuế GTGT'},
        {key:'service_money_tax_text',name:'Tiền thuế GTGT'},
        {key:'service_total_price_payment_text',name:'Thành tiền'},
        {key:'check_staff_comments_text',name:'Ý kiến nhân viên về sử dụng sản phẩm'},
        {key:'modified_date_text',name:'Ngày giao trả'}, 
      ],//tổng số cột
      columnShowShowExport : [],
      userID : null,
      filter_export : {},
      DisableExport : true,
      totalWarranty: 0,
      totalRepair: 0,
      totalMaintenance : 0,
      totalRepairAppraisal: 0,
      totalAppraisal: 0,
      totalOperation: 0,
      totalAcceptance: 0,
      totalTraining : 0,
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    backList() {
      this.$router.push({path: '/admin/report'});
    },
    info_overview(total_overview){
      this.totalMaintenance = (!this.$myConstants.isEmpty(total_overview["totalMaintenance"])) ? total_overview["totalMaintenance"]:0;
      this.totalRepairAppraisal = (!this.$myConstants.isEmpty(total_overview["totalRepairAppraisal"])) ? total_overview["totalRepairAppraisal"]:0;
      this.totalWarranty = (!this.$myConstants.isEmpty(total_overview["totalWarranty"])) ? total_overview["totalWarranty"]:0;
      this.totalRepair = (!this.$myConstants.isEmpty(total_overview["totalRepair"])) ? total_overview["totalRepair"]:0;
      this.totalAppraisal = (!this.$myConstants.isEmpty(total_overview["totalAppraisal"])) ? total_overview["totalAppraisal"]:0;
      this.totalOperation = (!this.$myConstants.isEmpty(total_overview["totalOperation"])) ? total_overview["totalOperation"]:0;
      this.totalAcceptance = (!this.$myConstants.isEmpty(total_overview["totalAcceptance"])) ? total_overview["totalAcceptance"]:0;
      this.totalTraining = (!this.$myConstants.isEmpty(total_overview["totalTraining"])) ? total_overview["totalTraining"]:0;
    },
    async validationFilterData() {
      //var vm =this;
      this.validationErrors = {};
      if (this.$myConstants.isEmpty(this.list_filter_data["start_date_filter"]) || this.$myConstants.isEmpty(this.list_filter_data["end_date_filter"])){
        this.validationErrors['start_date_filter'] = 'Nhập thời gian tiếp nhận';
      }
      else {
        var check_start_date = moment(this.list_filter_data["start_date_filter"]).tz(this.$myConstants.timeZone()).format('YYYYMMDD');
        var check_end_date = moment(this.list_filter_data["end_date_filter"]).tz(this.$myConstants.timeZone()).format('YYYYMMDD');
        if (check_end_date < check_start_date){
          this.validationErrors['start_date_filter'] = 'Nhập ngày bắt đầu không được lớn hơn ngày kết thúc ';
        }
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    cancel_filter(){
      this.validationErrors = {}
      this.DisableExport = true;
      this.list_filter_data = {};
      this.totalWarranty = 0,
      this.totalRepair = 0,
      this.totalMaintenance = 0,
      this.totalRepairAppraisal= 0,
      this.totalAppraisal= 0,
      this.totalOperation= 0,
      this.totalAcceptance= 0,
      this.totalTraining = 0,
      this.map_custom_filter = [];
      this.process_load_data();
    },
    async process_filter() {
      //var vm = this;
      await this.validationFilterData();
      if (Object.entries(this.validationErrors).length === 0) {
        /*this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);*/
        //this.map_custom_filter
        this.DisableExport = false;
        this.process_load_data();
      }
    },
    async process_load_data() {
      console.log("AAAA")
      this.processColunmDisplays();
      this.dataModel = DataServices.getModel('report_warranty_repair');
      this.dataModel.processData([]);
      this.listDataExport = [];
      this.listData = [];
      this.componentKey++;
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    initData() {
      setTimeout(async () => {
        //if (this.$myConstants.checkRoleGroup('maintenance', 'list')) {
          await this.initParams();
        //}
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {

      /*this.filters = {
        date_maintenance: {
          from:  new Date(moment().startOf('month').format('YYYY-MM-DD')),
          to: new Date(moment().endOf('month').format('YYYY-MM-DD'))
        },
        type_maintenance:0,
        is_assignment:false
      };*/

      var vm = this;
      this.dateTypeDateFilterDefault = 2;
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      //this.filters.address_info = "aa";
      this.modelName = 'report_warranty_repair';
      //load filter đơn vị
      this.$coreService.list_all_organization().then(async (dataOr) => {
        vm.list_filter_organization = dataOr;
      }).catch(async () => {
        vm.list_filter_organization = [];
      });
      this.$coreService.get_type_failure_cause_all().then(async (dataOr) => {
        vm.list_type_failure_cause = dataOr;
      }).catch(async () => {
        vm.list_type_failure_cause = [];
      });
      this.$coreService.list_all_product().then(async (data) => {
        vm.list_filter_product = data;
      }).catch(async () => {
        vm.list_filter_product = [];
      });
      this.$coreService.get_warranty_repair_type_service_all().then(async (data) => {
        vm.list_filter_service_status = data;
      }).catch(async () => {
        vm.list_filter_service_status = [];
      });
      
      this.processColunmDisplays();
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData([]);
      this.listDataExport = [];
      this.listData = [];
      this.componentKey++;
      this.$store.commit('setLoading', false);
    },
    processColunmDisplays(){
      var colunmHide = [];
      var columnShow = []
      for (var i=0;i<this.list_column_select.length;i++){
        var key = this.list_column_select[i].key;
        if (this.list_colunm_display.indexOf(key) == -1){
          colunmHide.push(key);
        }else{
          columnShow.push(key);
        }
      }
      this.columnsDisplays = colunmHide;
      this.columnShowExport = columnShow;
    },
    dang_phat_trien(){
      alert('Đang phát triển');
    },
    redirect_ToHistory(){
      this.$router.push({path: '/admin/history-export'});
    },
    async  filterData(payload){
      console.log("assssssssss:",this.filters)
      this.listDataExport = payload.filteredValue;
    },
    async exportDataExcel(){
    var columnExport = this.columnShowExport;
    if (columnExport.length < 1){
      this.$toast.add({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Không tồn tại cột dữ liệu xuất',
        life: 3000
      });
      return false;
    }
    this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
    this.$store.commit('setLoading', true);
      try {
        var start_date_filter = moment(this.list_filter_data["start_date_filter"]).format('DDMMYY');
        var end_date_filter = moment(this.list_filter_data["end_date_filter"]).format('DDMMYY');
        //console.log(start_date_filter)
        //console.log(end_date_filter)
        var dataResponse = await this.$coreService.callApiPost('/export_excel/report_repair_warranty_maintenance',{column_export:columnExport,user_id : this.userID,filter_export : this.filter_export},{})
        var key_s3 = dataResponse.data.data.key_s3;
        var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:key_s3},{})
        var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
          type: 'application/vnd.ms-excel'
        }))
        const link = document.createElement('a')
        link.href = url;
        var file_excel = 'BC_SuaChuaBaoHanhBaoTri_'+moment().tz("Asia/Bangkok").format('DDMMYYYY')+'_'+moment().tz("Asia/Bangkok").format('HHmmss')+'_'+start_date_filter+'-'+end_date_filter+'.xlsx';
        link.setAttribute('download', file_excel)
        document.body.appendChild(link)
        link.click()
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_success';

    } catch (err) {
        console.log("err:",err);
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_err';
      }
      this.$store.commit('setLoading', false);
    },
    callbackListData(col, payload) {
      //var vm = this;
      //console.log("5555555555");
      if (col.name == 'is_assignment') {
        this.disable_update = false;
        if (payload);
      }
    },
   async update_assignment(){
      if (this.disable_update == false){
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var list_id_update_false = [];
        var list_id_update_true = [];
        for (var i=0;i<this.listData.length;i++){
          if (this.listData[i].type_maintenance == 0){
            if (this.listData[i].is_assignment == true){
              list_id_update_true.push(this.listData[i].id);
            }else {
              list_id_update_false.push(this.listData[i].id);
            }
          }
        }
        var count_done = 0;
        var whereInfoTrue = { id: {_in: list_id_update_true} }
        DataServices.updateData('maintenance', {"variables": JSON.stringify({data_update: {is_assignment:  true}, where_key: whereInfoTrue})}).then(async () => {
          count_done++;
          if (count_done == 2){
            this.disable_update = true;
            this.update_assignment_success();
          }
        }).catch(async () => {
          count_done++;
          //báo lỗi 1 lần
          if (count_done == 1){
            this.disable_update = true;
            this.update_assignment_err();
          }
        });

          var whereInfoFalse = { id: {_in: list_id_update_false} }
          DataServices.updateData('maintenance', {"variables": JSON.stringify({data_update: {is_assignment:  false}, where_key: whereInfoFalse})}).then(async () => {
            count_done++;
            if (count_done == 2){
              this.disable_update = true;
              this.update_assignment_success();
            }
          }).catch(async () => {
            count_done++;
            if (count_done == 1){
              this.disable_update = true;
              this.update_assignment_err();
            }
          });
      }
    },
    update_assignment_success(){
      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 });
    },
    update_assignment_err(){
      this.$store.commit('setLoading', false);
      this.$toast.add({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
        life: 3000
      });
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'view':
          this.$router.push(action.path + '/' + data.data[action.key])
          break;
      }
    },
    /*getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
          var process_status = (!that.$myConstants.isEmpty(rowData.process_status)) ? rowData.process_status:null;
          var path = "";
          var modelaction;
          if (that.$myConstants.checkRoleGroup('warranty_repair', 'add')  && (process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.PLAN || process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.MAINTENANCE_NEEDED) ){
            path = "/admin/warranty-repair/function?id_maintenance="+rowData.id;
            buttons.edit = { name: 'add_warranty_repair', text: 'Tiếp nhận', isText: true,  key: 'id', path: path}
            if (that.dataModel.actions) {
               modelaction = that.dataModel.actions(rowData)
              Object.assign(buttons, modelaction);
            }
          }else if (that.$myConstants.checkRoleGroup('warranty_repair', 'view')  && (process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.PROCESSING || process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.FOR_MAINTENANCE) ){
            if (!that.$myConstants.isEmpty(rowData.id_wr_product)){
              var warranty_repair_product_serial_number_id = rowData.id_wr_product;
              path = "/admin/warranty-repair/view-detail/"+warranty_repair_product_serial_number_id;
              buttons.edit = { name: 'view_warranty_repair_product', text: 'Xem', isText: true,  key: 'id', path: path}
              if (that.dataModel.actions) {
                modelaction = that.dataModel.actions(rowData)
                Object.assign(buttons, modelaction);
              }
            }
          }
        return buttons
      }
      return actions
    },*/
    getRowActions() {
      var actions = {}
      var that = this;
      actions.rows = function (rowData) {
        var buttons = {}
        buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/warranty-repair/view-detail`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
    },
    async onFilter(event,type_input,key) {
      /*console.log(type_input)
      console.log(key)
      console.log("event:",this.list_filter_data)*/
      //this.list_filter_data
      if (type_input == 'date_from_to'){
        if (!this.$myConstants.isEmpty(this.list_filter_data["start_date_filter"]) && !this.$myConstants.isEmpty(this.list_filter_data["end_date_filter"])){
          this.list_filter_data["receive_day_reception"] = [this.list_filter_data["start_date_filter"],this.list_filter_data["end_date_filter"]]
        key = 'receive_day_reception';
        type_input = 'DateRange';
        }
      }
      this.map_custom_filter[key] = await this.$coreService.convertFilter(type_input,key,this.list_filter_data);
      //console.log("this.map_custom_filter:",this.map_custom_filter)
      //console.log("this.map_custom_filter:",this.map_custom_filter)
      //this.lazyParams.first = 0;
      //this.onLazyEvent()
    },
    async whereExport(e){
      // console.log("EEE",e)
      this.filter_export = e
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.list_warranty_repair{
  .late_delivery_return_appointment_day{
    color: #CC0000;
  }
}

.import-data .download-file {
  color: #fff;
  border-width: 0px;
  min-width: 165px;
  height: 35px;
  background: #169bd5;
  border: none;
  border-radius: 5px;
  padding: 5px 20px;
}
.download-data{ position: relative; display: flex;
  span{margin-top: 14px; margin-left: 10px;}
}

.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
.box-row-data{
  margin: 0px 0px !important;
  .box-item-data:first-child{
    padding-left: 0px !important;
  }
  .box-item-data:last-child{
    padding-right: 0px !important;
  }
}
.box-button-filter{
  position: relative;
  .box-item-button-filter{
    position: absolute;
    bottom: 16px;
  }
}
</style>
<style>
.p-checkbox .p-hidden-accessible{
  position: unset!important;
}
.custom-number-overview{
  font-weight: 700;
}
</style>